import { Skeleton } from 'antd';
import { Column, Space } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils/constants';

import CheckFilterDesktop from './CheckFilterDesktop';
import CheckFilterMobile from './CheckFilterMobile';
import * as S from './styles';

const CheckFilterItem = ({
  id = '',
  selected = false,
  image,
  children,
  onSelect = (filterId: string) => 0,
  width,
  height,
  canDeselect = true,
  typeSelectCreate = false,
}: CheckFilterItemProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const handleClick = () => {
    if (canDeselect || !selected) {
      onSelect(id);
    }
  };

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <CheckFilterDesktop
        handleClick={handleClick}
        height={height}
        image={image}
        selected={selected}
        tooltip={children}
        typeSelectCreate={typeSelectCreate}
        width={width}
      />
    ),
    [DEVICES.MOBILE]: (
      <CheckFilterMobile
        handleClick={handleClick}
        height={height}
        image={image}
        selected={selected}
        tooltip={children}
        typeSelectCreate={typeSelectCreate}
        width={width}
      />
    ),
    [DEVICES.TABLET]: (
      <CheckFilterMobile
        handleClick={handleClick}
        height={height}
        image={image}
        selected={selected}
        tooltip={children}
        typeSelectCreate={typeSelectCreate}
        width={width}
      />
    ),
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default CheckFilterItem;

export interface CheckFilterItemProps {
  id?: string;
  image: string;
  children: string;
  selected?: boolean;
  onSelect?: (id: string) => void;
  width?: string;
  height?: string;
  canDeselect?: boolean;
  typeSelectCreate?: boolean;
}

export const CheckFilterItemSkeleton = ({
  width,
  height,
}: CheckFilterItemSkeletonProps): JSX.Element => (
  <S.Wrapper height={height} selected={false} width={width}>
    <Column alignItems="center">
      <S.ImageWrapper>
        <Skeleton.Avatar shape="square" size={48} />
      </S.ImageWrapper>
      <Space height={12} />
      <Skeleton.Input size="small" style={{ width: '100%' }} />
    </Column>
  </S.Wrapper>
);

export interface CheckFilterItemSkeletonProps {
  width?: string;
  height?: string;
}
